import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ExpedienteDto } from '../../../dto/expediente/expediente.dto';
import { TableColumn } from '../../../dto/util/table-column';
import { FiltroDto } from '../../../dto/util/filtro-dto';
import { ExpedienteFiltroDto } from '../../../dto/expediente/expediente.filtro.dto';
import { UserDataDto } from '../../../dto/auth/user-data.dto';
import { PoliticaTratamientoDatosPersonalesComponent } from '../../util/modal-politica/politica-tratamiento-datos-personales/politica-tratamiento-datos-personales.component';
import { ExpedienteService } from '../../../services/expediente.service';
import { ListasService } from '../../../services/listas.service';
import { UtilService } from '../../../services/util.service';
import { SpinnerService } from '../../../services/util/spinner.service';
import { EntidadDto } from '../../../dto/expediente/entidad.dto';
import { TipoProcesoDto } from '../../../dto/expediente/tipo-proceso.dto';
import { EstadoExpedienteDto } from '../../../dto/expediente/estado-expediente.dto';
import { Constants } from '../../../constants/constants';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { EntidadSegundaInstanciaDto } from '../../../dto/expediente/entidad-segunda-instancia.dto';
import { SegundaInstanciaService } from '../../../services/segunda-instancia.service';
import { TableAction } from '../../../dto/util/table-action';
import { FormField } from '../../../dto/util/form-field';
import { WrapperExpedienteDto } from '../../../dto/expediente/wrapper-expediente.dto';
import { CambioExpedienteSegundaInstanciaDto } from '../../../dto/expediente/cambio-expediente-segunda-instancia.dto';
import { ModalAgregarEntidadSegundaInstanciaComponent } from '../modal-agregar-entidad-segunda-instancia/modal-agregar-entidad-segunda-instancia.component';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-gestion-expediente-administrador',
  templateUrl: './gestion-expediente-administrador.component.html',
  styleUrl: './gestion-expediente-administrador.component.scss',
})
export class GestionExpedienteAdministradorComponent
  implements OnInit
{
  @ViewChild(PoliticaTratamientoDatosPersonalesComponent)
  politicaTratamientoDatosPersonalesComponent!: PoliticaTratamientoDatosPersonalesComponent;

  @ViewChild(ModalAgregarEntidadSegundaInstanciaComponent)
  modalAgregarEntidadSegundaInstanciaComponent!: ModalAgregarEntidadSegundaInstanciaComponent;

  disabledEnviarASegundaInstancia: Boolean = true;
  actualizarGuardadoEntidad: Boolean = true;
  openModalAgregarSegundaInstancia: boolean = false;
  formFields: FormField[] = [];
  expedientes: WrapperExpedienteDto[] = [];
  expedientesSeleccionados: WrapperExpedienteDto[] = [];
  entidades: EntidadDto[] = [];
  entidadesSegundaInstancia: EntidadSegundaInstanciaDto[] = [];
  tiposProceso: TipoProcesoDto[] = [];
  estados: EstadoExpedienteDto[] = [];
  columns: TableColumn[] = [];
  acciones: TableAction[] = [];
  tamanoPagina = 5;
  totalPaginas = 0;
  paginaActual = 1;
  userData: UserDataDto = {};
  filtros: FiltroDto<ExpedienteFiltroDto> = {
    pagina: 1,
    tamanoPagina: this.tamanoPagina,
    ordenarAsc: false,
    ordenarPor: 'Radicado',
    filtros: {},
  };
  esBuscar?: boolean;
  // Multilenguaje
  tableText: any = {};
  guiaText: any = {};
  guiaGestionExpedienteText: any = {};
  modalText: any = {};

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;

  constructor(
    private segundaInstanciaService: SegundaInstanciaService,
    private expedienteService: ExpedienteService,
    private listasService: ListasService,
    private router: Router,
    private utilService: UtilService,
    private spinnerService: SpinnerService,
    private translate: TranslateService,
    private alertaModalService: AlertaModalService,
  ) {
    // Multilenguaje
    combineLatest({
      guia: this.translate.stream('guias-interactivas'),
      tablas: this.translate.stream('gestion-expedientes-administrador-tabla'),
      guiaExpediente: this.translate.stream('guia-gestion-expediente'),
      modal: this.translate.stream('modal-segunda-instancia'),
    }).subscribe(({ guia, tablas, guiaExpediente , modal}) => {
      // Asignar traducciones a variables
      this.guiaText = guia;
      this.tableText = tablas;
      this.guiaGestionExpedienteText = guiaExpediente;
      this.modalText = modal
      // Construir formularios después de cargar traducciones
      this.initColumns();
    });
  }

  ngOnInit(): void {
    // Se toma la información del usuario que inicia sesión
    this.userData = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.filtros.filtros.entidad = this.userData.tipoUsuario?.Id_Entidad
    this.initColumns();
    this.listarExpedientes();
    this.listarEntidades();
    this.listarTiposProceso();
    // this.listarEstados();
    this.listarEntidadesSegundaInstancia();
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: this.guiaGestionExpedienteText['titulo'],
      descripcionPantalla:
      this.guiaGestionExpedienteText['descripcion'],
      pasos: [
        {
          element: '#tour',
          popover: {
            title: this.guiaGestionExpedienteText['tour-titulo'],
            description:
            this.guiaText['tour-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#navbarDropdownDetalle',
          popover: {
            title: this.guiaText['usuario-titulo'],
            description: this.guiaText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#dropdownAlertasButton',
          popover: {
            title: this.guiaText['alertas-titulo'],
            description: this.guiaText['alertas-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#glosario',
          popover: {
            title: this.guiaText['glosario-titulo'],
            description: this.guiaText['glosario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#informacion',
          popover: {
            title: this.guiaText['info-titulo'],
            description: this.guiaText['info-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#filtro',
          popover: {
            title: this.guiaGestionExpedienteText['filtro-titulo'],
            description: this.guiaGestionExpedienteText['filtro-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#crearSolicitud',
          popover: {
            title: this.guiaGestionExpedienteText['crear-solicitud-titulo'],
            description: this.guiaGestionExpedienteText['crear-solicitud-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historico',
          popover: {
            title: this.guiaGestionExpedienteText['historico-titulo'],
            description: this.guiaGestionExpedienteText['historico-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#Radicado',
          popover: {
            title: this.guiaGestionExpedienteText['proceso-titulo'],
            description: this.guiaGestionExpedienteText['proceso-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#entidad',
          popover: {
            title: this.guiaGestionExpedienteText['entidad-titulo'],
            description: this.guiaGestionExpedienteText['entidad-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#tipoProceso',
          popover: {
            title: this.guiaGestionExpedienteText['tipo-proceso-titulo'],
            description: this.guiaGestionExpedienteText['tipo-proceso-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#Fecha_Creacion',
          popover: {
            title: this.guiaGestionExpedienteText['fecha-creacion-titulo'],
            description: this.guiaGestionExpedienteText['fecha-creacion-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#Fecha_Ultima_Modificacion',
          popover: {
            title: this.guiaGestionExpedienteText['fecha-actualizacion-titulo'],
            description: this.guiaGestionExpedienteText['fecha-actualizacion-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#estado',
          popover: {
            title: this.guiaGestionExpedienteText['estado-titulo'],
            description: this.guiaGestionExpedienteText['estado-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
      ],
    };
    // Se valida que sea el primer inicio de sesión para ejecutar la guía interactiva
    if (this.userData.primerInicioSesion) {
      this.utilService.changeInfoPantalla(this.infoPantalla);
      this.utilService.iniciarGuiaInteractiva();
    } else {
      this.utilService.changeInfoPantalla(this.infoPantalla);
    }
    this.utilService.show();
  }

  listarExpedientes() {
    this.expedienteService.getExpedientes(this.filtros).subscribe(data => {

      this.expedientes = data.registros.map(item => {
        const newItem: WrapperExpedienteDto = {
          ...item,
          Estado_Expediente: item.Estado_Expediente ? item.Estado_Expediente : {Estado: '', Proceso_Finalizado: false},
          Disabled_Segunda_Instancia: true,
        }
        return newItem
      });
      this.estados = Array.from(
        new Map(
          this.expedientes
            .map(item => item.Estado_Expediente)
            .filter((estado): estado is EstadoExpedienteDto => estado !== undefined)
            .map(estado => [estado.Id, estado])
        ).values()
      );
      this.totalPaginas = data.totalPaginas;
      this.paginaActual = data.numeroPagina;
      this.initColumns();
    });
    if (this.esBuscar) {
      this.spinnerService.hideSpinner();
    }
  }

  listarEntidades() {
    this.listasService.getEntidades().subscribe(data => {

      this.entidades = data.filter(item=> item.Id == this.userData.tipoUsuario?.Id_Entidad);
      this.initColumns();
    });
  }

  listarTiposProceso() {
    this.listasService
      .getTiposProceso(this.filtros.filtros.entidad || 0)
      .subscribe(data => {
        this.tiposProceso = data;
        this.initColumns();
      });
    if (this.esBuscar) {
      this.spinnerService.hideSpinner();
    }
  }

  listarEntidadesSegundaInstancia(){
    this.segundaInstanciaService.getEntidadesSegundaInstancia().subscribe(
      data=> {
        this.entidadesSegundaInstancia = data
        this.initColumns()
      })
  }

  listarEstados() {
    this.listasService
      .getEstadosExpediente(this.filtros.filtros.entidad || 0)
      .subscribe(data => {
        if (this.filtros.filtros.entidad) {
          this.estados = data;
        } else {
          this.estados = data.map(estado => {
            estado.Estado = `${estado.Estado} - ${estado.Entidad?.Entidad}`;
            return estado;
          });
        }
        this.initColumns();
      });
    if (this.esBuscar) {
      this.spinnerService.hideSpinner();
    }
  }

  buscar(event: FiltroDto<object>) {
    this.esBuscar = true;
    this.filtros.ordenarPor =
      event.ordenarPor == '' ? 'Radicado' : event.ordenarPor;
    this.filtros.filtros = event.filtros as ExpedienteFiltroDto;
    if (this.filtros.filtros.numeroProceso) {
      this.filtros.filtros.numeroProceso =
        this.filtros.filtros.numeroProceso.toString();
    }
    if (this.filtros.filtros.estado) {
      this.filtros.filtros.estado = +this.filtros.filtros.estado;
    }
    if (this.filtros.filtros.tipoProceso) {
      this.filtros.filtros.tipoProceso = +this.filtros.filtros.tipoProceso;
    }
    if (this.filtros.filtros.entidad) {
      this.filtros.filtros.entidad = +this.filtros.filtros.entidad;
    }
    this.filtros.filtros.entidad = this.userData.tipoUsuario?.Id_Entidad
    this.filtros.ordenarAsc = event.ordenarAsc;
    this.filtros.pagina = +(event.selectedPage ?? 1);
    this.filtros.tamanoPagina = +event.tamanoPagina;
    this.listarExpedientes();
    this.listarTiposProceso();
    // this.listarEstados();
  }

  initColumns() {
    this.columns = [
      {
        field: 'Radicado',
        title: this.tableText['numero-proceso'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'numeroProceso',
        width: '10rem',
        accion: (item: ExpedienteDto) => {
          if (item.Estado_Expediente?.Proceso_Finalizado) {
            this.utilService.hide();
          }
          switch (item?.Tipo_Proceso?.Entidad_Id) {
            case 1:
              if (!item?.Tipo_Proceso?.Tipo_Proceso?.includes("Insolvencia")){
                this.router.navigate(['/expediente/ssm', item.Id, (item.Usuario_Id_Creador??0)]);
              } else {
                this.router.navigate(['/expediente/supersociedades', item.Id, (item.Usuario_Id_Creador??0)]);
              }
              break;
            case 2:
              this.router.navigate(['/expediente/sic/', item.Id, (item.Usuario_Id_Creador??0)]);
              break;
            case 3:
              this.router.navigate(['/expediente/supersalud', item.Id, (item.Usuario_Id_Creador??0)]);
              break;
            case 4:
              this.router.navigate(['/expediente/superfinanciera', item.Id, (item.Usuario_Id_Creador??0)]);
              break;
            case 5:
              this.router.navigate(['/expediente/dnda', item.Id, (item.Usuario_Id_Creador??0)]);
              break;
            case 6:
              this.router.navigate(['/expediente/dimar', item.Id, (item.Usuario_Id_Creador??0)]);
              break;
            case 7:
              this.router.navigate(['/expediente/ica', item.Id, (item.Usuario_Id_Creador??0)]);
              break;
            case 8:
              this.router.navigate(['/expediente/ssm', item.Id, (item.Usuario_Id_Creador??0)]);
              break;
            default:
              break;
          }
        },
      },
      {
        id: 'entidad',
        field: 'Tipo_Proceso.Entidad.Entidad',
        title: this.tableText['entidad'],
        type: 'select',
        filterable: true,
        visible: false,
        sortable: true,
        fieldFilterElement: 'entidad',
        elements: this.entidades,
        option: 'Entidad',
        value: 'Id',
        width: '15rem',
      },
      {
        id: 'tipoProceso',
        field: 'Tipo_Proceso.Tipo_Proceso',
        title: this.tableText['tipo-proceso'],
        type: 'select',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'tipoProceso',
        elements: this.tiposProceso,
        option: 'Tipo_Proceso',
        value: 'Id',
        width: '15rem',
      },
      {
        field: 'Fecha_Creacion',
        title: this.tableText['fecha-creacion'],
        type: 'date',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'fechaCreacion',
        pipe: 'dd/MM/yyyy',
        width: '15rem',
      },
      {
        field: 'Fecha_Ultima_Modificacion',
        title: this.tableText['fecha-actualizacion'],
        type: 'date',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'fechaActualizacion',
        pipe: 'dd/MM/yyyy',
        width: '15rem',
      },
      {
        id: 'estado',
        field: 'Estado_Expediente.Estado',
        title: this.tableText['estado'],
        type: 'select',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'estado',
        elements: this.estados,
        option: 'Estado',
        value: 'Id',
        width: '15rem',
      },
      {
        id: 'segundaInstancia',
        field: 'Id_Segunda_Instancia',
        title: this.tableText['segunda-instancia'],
        type: 'inputselect',
        enabledAction: 'Disabled_Segunda_Instancia',
        elements: this.entidadesSegundaInstancia,
        option: 'Entidad',
        value: 'Id',
        accion: (item)=>{this.accionSelectSegundaInstancia(item)},
        width: '15rem',
      },
    ];
  }

  handleSelectedItems(selectedItems: WrapperExpedienteDto[]) {
    this.expedientesSeleccionados = selectedItems
    const idSeleccionados = new Set(selectedItems.map(item => item.Id))
    this.expedientes.map(item => {
      item.Disabled_Segunda_Instancia = !idSeleccionados.has(item.Id)
      item.Id_Segunda_Instancia = !idSeleccionados.has(item.Id) ? undefined : item.Id_Segunda_Instancia
    })
    if(this.expedientesSeleccionados.length == 0){
      this.disabledEnviarASegundaInstancia = true
    }else{
      const esValido = this.expedientesSeleccionados.every(
        (e) => e.Id_Segunda_Instancia !== null && e.Id_Segunda_Instancia !== undefined
      );
      if(esValido){
        this.disabledEnviarASegundaInstancia = false
      }else{
        this.disabledEnviarASegundaInstancia = true
      }
    }
  }

  guardadoEntidad(guardado: boolean){
    if(guardado){
      this.alertaModalService.alertaAccion(
        "exito",
        this.modalText['entidad-creada-titulo'],
        this.modalText['entidad-creada'],
        ()=>{
          this.reloadPage()
        },
        ()=>{
          this.reloadPage()
        }
      );

    }else{
      this.alertaModalService.alertaAccion(
        "error",
        this.modalText['entidad-duplicada'],
        this.modalText['error-entidad'],
        ()=>{
        this.modalAgregarEntidadSegundaInstanciaComponent.abrirCerrarModal()
      },()=>{})
    }
  }

  accionSelectSegundaInstancia(seleccion: any){
    const esValido = this.expedientesSeleccionados.every(
      (e) => e.Id_Segunda_Instancia !== null && e.Id_Segunda_Instancia != "undefined"
    );
    if(esValido){
      this.disabledEnviarASegundaInstancia = false
    }else{
      this.disabledEnviarASegundaInstancia = true
    }
  }

  enviarSegundaInstancia(){
    const request: CambioExpedienteSegundaInstanciaDto[] = this.expedientesSeleccionados.map(item => {
      return {
        idExpediente: item.Id!!,
        idEntidadSegundaInstancia: Number(item.Id_Segunda_Instancia!),
        idUsuarioRegistro: this.userData.idUsuario!
      }
    });

    this.segundaInstanciaService.cambioExpedienteASegundaInstancia(request).subscribe({
      next: (resp) =>{
        if(resp.success == true){
          this.alertaModalService.exito(
            this.modalText['expediente-enviado-titulo'],
            this.modalText['expediente-enviado']
          );
          setTimeout(() => {
            this.reloadPage()
          }, 5000);
        }else{
          this.alertaModalService.error(
            this.modalText['error-titulo'],
            this.modalText['error']
          );
        }
      },
      error: (err: Error)=>{
        this.alertaModalService.error(
          this.modalText['error'],
          err.message
        );
      }
    })
  }

  agregarEntidadSegundaInstancia(){
    this.openModalAgregarSegundaInstancia = true;
    setTimeout(() => {
      this.modalAgregarEntidadSegundaInstanciaComponent.abrirCerrarModal()
    }, 500);
  }

  reloadPage(){
    window.location.reload();
  }
}
